// extracted by mini-css-extract-plugin
module.exports = {"container":"FundraiserOrganizationInfo_container__0CZFJ","logo":"FundraiserOrganizationInfo_logo__VSNie","text":"FundraiserOrganizationInfo_text__ST91d"};